var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "1000px",
        title: "批量同步商品",
        visible: _setup.props.isShowing,
        "before-close": _setup.changeIsShowing,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_setup.props, "isShowing", $event)
        },
        open: _setup.onSearch,
      },
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", gap: "12px" } },
        [
          _c("div", [_vm._v("确定将以下选中商品")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _setup.isPublish,
                callback: function ($$v) {
                  _setup.isPublish = $$v
                },
                expression: "isPublish",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [
                _vm._v("同步为推荐商品并发布"),
              ]),
              _c("el-radio", { attrs: { label: 0 } }, [
                _vm._v("同步为推荐商品但不发布"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "batch-sync-form",
          staticStyle: { margin: "24px 0" },
          attrs: {
            size: "mini",
            inline: true,
            model: _setup.form,
            "label-width": "auto",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品ID" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入商品ID" },
                model: {
                  value: _setup.form.goodsId,
                  callback: function ($$v) {
                    _vm.$set(_setup.form, "goodsId", $$v)
                  },
                  expression: "form.goodsId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入商品名称" },
                model: {
                  value: _setup.form.goodsName,
                  callback: function ($$v) {
                    _vm.$set(_setup.form, "goodsName", $$v)
                  },
                  expression: "form.goodsName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _setup.onSearch } },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _setup.isLoading,
                  expression: "isLoading",
                },
              ],
              attrs: { border: "", data: _setup.datas, "row-key": "id" },
              on: { "selection-change": _setup.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "id", label: "商品ID", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称", "min-width": "250" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "coverImgUrl",
                  label: "商品封面图",
                  "min-width": "81",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.coverImgUrl
                          ? _c("el-image", {
                              staticStyle: {
                                width: "60px",
                                "min-height": "60px",
                              },
                              attrs: {
                                src:
                                  row.coverImgUrl.split(",")[0] ??
                                  row.imageUrls.split(",")[0],
                                "preview-src-list":
                                  row.coverImgUrl.split(",") ??
                                  row.imageUrls.split(",")[0],
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "backGoryName",
                  label: "商品类目",
                  "min-width": "200",
                },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              "page-sizes": [10, 20, 30],
              total: _setup.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _setup.handleSizeChange,
              "current-change": _setup.handleCurrentChange,
            },
            model: {
              value: _setup.pageSize,
              callback: function ($$v) {
                _setup.pageSize = $$v
              },
              expression: "pageSize",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "24px",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
            },
            [
              _c("el-button", { on: { click: _setup.changeIsShowing } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _setup.isBatchSync },
                  on: { click: _setup.requestOfBatchSync },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }